import React from 'react'
import { Loading } from 'antd-mobile-v5'
import { FormattedMessage } from 'react-intl'
import styles from './tools.module.css'

const LoadingStatus = ({ color }) => {
  return (
    <div className={styles.loading} style={{ color: color || '' }}>
      <Loading color={color || 'primary'} />
      <span>
        <FormattedMessage id="common-loading" />
      </span>
    </div>
  )
}

export default LoadingStatus
